var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconGrayCircleBlackTickFollowing = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 18,
  height: 19,
  viewBox: "0 0 18 19",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  y: 0.5,
  width: 18,
  height: 18,
  rx: 9,
  fill: "#CCCCCC"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13.9821 6.6586L13.4232 6.125L7.37772 11.8949L4.4964 9.145L3.9375 9.67861L7.3709 12.9554L7.65406 12.698L13.9821 6.6586Z",
  fill: "black"
})));
export default SvgIconGrayCircleBlackTickFollowing;